

































/* eslint-disable guard-for-in */
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import fcMsg from './fcMsg.json';
import { options } from '@/modules/FPKG-20000-Util/prototypes/axios';

@Component
export default class HeaderMessage extends Vue {
  private messages: any = {};

  private hudcount: number = 0;

  private websock: any = null;

  @Watch('ApplyCount')
  onApplyCount(val: number, oldval: number) {
    this.messages['p9_transaction_apply_count'] = val;
    this.totalHudCount();
  }

  @Watch('ReplyCount')
  onReplyCount(val: number, oldval: number) {
    this.messages['p9_transaction_reply_count'] = val;
    this.totalHudCount();
    if (val > oldval) {
      this.playaudio();
    }
  }

  get ApplyCount() {
    const count = this.$store.state.getTransfer.transfer
      .p9_transaction_apply_count;
    return count;
  }

  get ReplyCount() {
    const count = this.$store.state.getTransfer.transfer
      .p9_transaction_reply_count;
    return count;
  }

  // 權限判斷
  private Promotion(key: string): boolean {
    // 找到路徑且移除 /
    const path = this.hudrouter[key].substr(1);
    const right: number = this.$getCrud(path);
    // eslint-disable-next-line no-bitwise
    const canAccess = (right & 4) !== 0;
    return canAccess;
  }

  /**
   * 需回復數量 p9_transaction_apply_count
   * 需歸檔數量 p9_transaction_reply_count
   */
  private hudrouter: any = {
    p9_transaction_reply_count: '/transaction/apply/lists',
    p9_transaction_apply_count: '/transaction/reply/lists',
  };

  /**
   * handleCommand
   */

  public handleCommand(key: string): void {
    const t = String(Date.now());
    this.$router.push({ path: this.hudrouter[key], query: { t: t } });
  }

  private totalHudCount() {
    this.hudcount = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const name in this.messages) {
      const crud = this.Promotion(name);
      // 擁有權限在加入
      if (crud) {
        this.hudcount += this.messages[name];
      }
    }
  }

  createFakeBtn() {
    const btn: any = document.getElementById('fakePlayBtn');
    btn.addEventListener('click', this.playMusic);
  }
  public playMusic() {
    const play: any = document.getElementById('bgMusic');
    const audioPlay = play.play();
    audioPlay
      .then(() => {})
      .catch((err: any) => {
        // eslint-disable-next-line no-console
        console.log(err);
      });
  }

  public playaudio() {
    const fakePlayBtn: any = document.getElementById('fakePlayBtn');
    fakePlayBtn.click();
  }

  private created() {
    const user = JSON.parse(localStorage.getItem('userInfo') || '{}');

    delete user.p3_account;
    delete user.p5_role_node;
    delete user.site_config;
    delete user.p11_ttl_exclude_account;
    this.messages = user;

    this.totalHudCount();
  }

  private mounted() {
    this.createFakeBtn();
  }
}
